import { Code, ConnectError } from '@connectrpc/connect'

let active = false
let unavailableVersion = 0
const listeners = new Set()

function notify() {
  for (const listener of listeners) listener()
}

function setActive(nextActive) {
  if (active === nextActive) return
  active = nextActive
  notify()
}

export const maintenanceStore = {
  getSnapshot: () => active,
  getUnavailableVersion: () => unavailableVersion,
  subscribe(listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  activate: () => {
    unavailableVersion += 1
    setActive(true)
  },
  deactivate: () => setActive(false),
  deactivateIfCurrent(version) {
    if (unavailableVersion === version) setActive(false)
  },
}

export function isMaintenanceError(error) {
  return ConnectError.from(error).code === Code.Unavailable
}

function deactivateIfCurrent(store, version) {
  if (store.deactivateIfCurrent) store.deactivateIfCurrent(version)
  else store.deactivate()
}

async function* monitorMaintenanceStream(message, store, requestUnavailableVersion) {
  try {
    for await (const value of message) {
      deactivateIfCurrent(store, requestUnavailableVersion)
      yield value
    }
  } catch (error) {
    if (isMaintenanceError(error)) store.activate()
    throw error
  }
}

export function createMaintenanceInterceptor(store = maintenanceStore) {
  return (next) => async (request) => {
    const requestUnavailableVersion = store.getUnavailableVersion?.() ?? 0

    try {
      const response = await next(request)

      if (response.stream) {
        return {
          ...response,
          message: monitorMaintenanceStream(response.message, store, requestUnavailableVersion),
        }
      }

      deactivateIfCurrent(store, requestUnavailableVersion)
      return response
    } catch (error) {
      if (isMaintenanceError(error)) store.activate()
      throw error
    }
  }
}
